// components/DamageBreakdown.tsx

import React from 'react';
import './TotalDamage.css';
import { getDamageTypeIcon, DamageSubType } from '../ComboDisplay/Events/utils';
import { GameLog } from '../../../Logs/LogsDisplay';
import { SimplifiedChampion } from '../../../../../gameTypes';

interface DamageBreakdownProps {
  logs: GameLog[]; // The logs to compute damage from (for this combo)
  targetChampionName?: string;
  targetMaxHealth: number; // Required targetMaxHealth prop
}

const TotalDamage: React.FC<DamageBreakdownProps> = ({ logs, targetChampionName, targetMaxHealth }) => {
  // Initialize damage breakdown
  const damageByType = {
    physical: 0,
    magic: 0,
    trueDamage: 0,
  };

  let totalDamageTaken = 0;
  
  // Calculate total damage taken
  logs.forEach((log) => {
    if (log.type === 'DamageTaken') {
      const damageAmount = log.details?.damageAmount || 0;
      totalDamageTaken += damageAmount;

      // Determine damage subtype
      const damageSubType = log.details.damageSubType;
      switch (damageSubType) {
        case DamageSubType.Physical:
          damageByType.physical += damageAmount;
          break;
        case DamageSubType.Magic:
          damageByType.magic += damageAmount;
          break;
        case DamageSubType.True:
          damageByType.trueDamage += damageAmount;
          break;
        default:
          break;
      }
    }
  });

  // Format damage with separate number and percentage components
  const formatDamage = (damage: number, targetMaxHealth: number) => {
    // Round damage to nearest integer
    const roundedDamage = Math.floor(damage);
    
    // Calculate percentage of target's max health
    const percentage = (damage / targetMaxHealth) * 100;
    return {
      damage: roundedDamage,
      percentage: percentage.toFixed(1)
    };
  };

  // Compute percentages for each damage type
  const { physical, magic, trueDamage } = damageByType;
  const physicalPercent = totalDamageTaken > 0 ? (physical / totalDamageTaken) * 100 : 0;
  const magicPercent = totalDamageTaken > 0 ? (magic / totalDamageTaken) * 100 : 0;
  const truePercent = totalDamageTaken > 0 ? (trueDamage / totalDamageTaken) * 100 : 0;

  const formattedDamage = formatDamage(totalDamageTaken, targetMaxHealth);

  return (
    <div className="total-damage">
      <div className="total-damage-value">
        <div className="damage-amount">{formattedDamage.damage}</div>
        <div className="damage-percentage">{formattedDamage.percentage}%</div>
      </div>
      <div className="damage-types-bar">
        {physical > 0 && (
          <div className="damage-type-bar physical" style={{ width: `${physicalPercent}%` }}>
          
          </div>
        )}
        {magic > 0 && (
          <div className="damage-type-bar magic" style={{ width: `${magicPercent}%` }}>
          </div>
        )}
        {trueDamage > 0 && (
          <div className="damage-type-bar true-damage" style={{ width: `${truePercent}%` }}>
          </div>
        )}
      </div>
    </div>
  );
};

export default TotalDamage;